module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashBoard"
  }, [(_vm.columns.column7.count !== 0) ? _c('div', {
    staticClass: "s1"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "professiy",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column7.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ПРОФЕССИЙ")])])], 1) : _vm._e(), (_vm.columns.column3.count !== 0) ? _c('div', {
    staticClass: "s2"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "obrazovatelOrganizatsiy",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column3.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ")])])], 1) : _vm._e(), (_vm.columns.column5.count !== 0) ? _c('div', {
    staticClass: "s3"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "rabotodateley",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column5.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("РАБОТОДАТЕЛЕЙ")])])], 1) : _vm._e(), (_vm.columns.column1.count !== 0) ? _c('div', {
    staticClass: "s4"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "expert",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column1.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ОБРАТИВШИХСЯ В ЦОПП")])])], 1) : _vm._e(), (_vm.columns.column9.count !== 0) ? _c('div', {
    staticClass: "s5"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "teacher",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column9.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ПРЕПОДАВАТЕЛЕЙ")])])], 1) : _vm._e(), (_vm.columns.column8.count !== 0) ? _c('div', {
    staticClass: "s6"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "kompetentsiy",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column8.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("КОМПЕТЕНЦИЙ")])])], 1) : _vm._e(), (_vm.columns.column4.count !== 0) ? _c('div', {
    staticClass: "s7"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "obrazovatelProgramm",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column4.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ОБРАЗОВАТЕЛЬНЫХ ПРОГРАММ")])])], 1) : _vm._e(), (_vm.columns.column6.count !== 0) ? _c('div', {
    staticClass: "s8"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "vakansiy",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column6.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ВАКАНСИЙ")])])], 1) : _vm._e(), (_vm.columns.column2.count !== 0) ? _c('div', {
    staticClass: "s9"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "okonchivshikhObucheniye",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column2.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ОКОНЧИВШИХ ОБУЧЕНИЕ")])])], 1) : _vm._e(), (_vm.columns.column10.count !== 0) ? _c('div', {
    staticClass: "s10"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIcon",
    attrs: {
      "icon-name": "obrativshikhsya",
      "size": "superLarge"
    }
  }), _c('div', {
    staticClass: "hint"
  }, [_c('p', {
    staticClass: "root"
  }, [_vm._v(_vm._s(_vm.columns.column10.count))]), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("ЭКСПЕРТОВ ВСР")])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a01c78","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/dashboard/dashboard.vue
// module id = eeb6d1a970eeede8a81f
// module chunks = 16